import { d as defineProperties_1 } from '../define-properties/index.js';
import '../call-bind/index.js';
import { i as implementation$1 } from './implementation.js';
import { p as polyfill } from './polyfill.js';
import { s as shim$1 } from './shim.js';
import { c as callBind$1 } from '../../_vendor/call-bind/index.js_commonjs-module.js';

var define = defineProperties_1;
var callBind = callBind$1.exports;

var implementation = implementation$1;
var getPolyfill = polyfill;
var shim = shim$1;

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var regexp_prototype_flags = flagsBound;

export { regexp_prototype_flags as r };
